import ActionReporterService from '../entrypoints/src/admin/services/action-reporter-service';

import { Controller } from "stimulus";
import AppointmentService from '../entrypoints/src/admin/services/appointment-service';

export default class extends Controller {
  static values = {
    reportableId: Number,
    action: String,
    subAction: String,
  }

  connect() {
    this.element.addEventListener('jitsi:start', (ev) => this.onNewMeeting(ev.detail?.api));
    this.element.addEventListener('jitsi:end', (ev) => this.endMeeting());
  }

  async onNewMeeting(api) {
    this.checkAppointmentId();
    this.actionReport = await ActionReporterService.reportAction('appointments', this.reportableIdValue, this.actionValue, this.subActionValue);
  }

  async endMeeting() {
    await ActionReporterService.endAction('appointments', this.reportableIdValue, this.actionReport.id);
  }

  async checkAppointmentId() {
    if (!this.reportableIdValue) {
      let appointment = await AppointmentService.patch(`${this.appointmentUrl(this.element.dataset)}.json`, true, { appointment: { 'note': (this.element.dataset.note || 'Aula Iniciada') } });
      this.reportableIdValue = appointment.id;
    }
  }

  appointmentUrl(dataset) {
    return dataset.url
      .replace('batch_schedule_id', dataset.batchScheduleId)
      .replace('service_id', dataset.serviceId)
      .replace('date', dataset.date)
      .replace('start_time', dataset.startTime)
      .replace('end_time', dataset.endTime)
      .replace('enrollment_contract_id', dataset.enrollmentContractId)
      .replace('enrollment_contract_schedule_id', dataset.enrollmentContractScheduleId);
  }
}
